import http, { url } from '../../http'

const API_URL = "ci_puntations"

class puntuationAPI {

 

  async getpuntuation(id,  page) {
    const response = await http(`${API_URL}/${id}?page=${page}` )
    return response
  } 
  async get(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response || null
  }

  async updatePuntuation(id, puntuacion) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', puntuacion)
    return response
  }
 
  async deletePuntuation(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new puntuationAPI()